import APIServiceBase from "./APIServiceBase";
import { registerAPIService } from "./APIServicesRegistry";

export default class TWSCalculationApiService extends APIServiceBase {
    constructor(endpointControllerName: string) {
        super(endpointControllerName || 'TWSCalculation')
    }

    calculateMatchingUnits(data: any) {
        return this.post("CalculateMatchingUnits", data)
    }

    calculateMatchingTapWaterSystems(data: any) {
        return this.post("CalculateMatchingTapWaterSystems", data)
    }

    calculateSelectedTapWaterData(data: any) {
        return this.post("CalculateSelectedTapWaterData", data)
    }

    getSelectedProductData(data: any) {
        return this.post("GetSelectedProductData", data)
    }

    getFileByOriginalName(data: any) {
        return this.get(`GetFile?originalName=${data.originalName}&maxWidth=${data.maxWidth}&maxWidth=${data.maxHeight}`, data);
    }

    getAvailableMatchingTankQuantities(data: any) {
        return this.post("GetAvailableMatchingTankQuantities", data);
    }

    getAvailableTankSelectionResults(data: any) {
        return this.post("GetAvailableTankSelectionResults", data);
    }

    getTechnicalDataOfTheTank(data: any) {
        return this.post("GetTechnicalDataOfTheTank", data)
    }

    getDocumentationModalContent(data: number): any;

    getDocumentationModalContent(data: {}): any;

    getDocumentationModalContent(data: any): any {
        if (typeof data === 'number')
            return this.get(`GetDocumentationModalContent?projectId=${data}`, {});
        else
            return this.post('GetDocumentationModalContent', data);
    }

    generateDocumentation(data: any): any {
        return this.post('GenerateDocument', data, 'blob');
    }

    getSummaryImages(data: any): any {
        return this.post('GetSummaryImages', data)
    }

    createCalculation(data: any) {
        return this.post('Create', data)
    }

    saveCalculation(data: any) {
        if (data.id === 0) {
            return this.createCalculation(data)
        }

        return this.post(`Edit/${data.id}`, data)
    }

    getAvailableTankMaterials(data: any) {
        return this.post('GetAvailableTankMaterials', data);
    }

    getAvailableTankVolumesForTankSelectionStep(data: any) {
        return this.post('GetAvailableTankVolumesForTankSelectionStep', data);
    }

    getAvailableTankVolumesForCapacityMethod(data: any) {
        return this.post('GetAvailableTankVolumesForCapacityMethod', data);
    }
}

registerAPIService(TWSCalculationApiService)